import { z } from 'zod';

// Helpers for preprocessing
const trim = (v) => (typeof v === 'string' ? v.trim() : v);
const toLowerTrim = (v) => (typeof v === 'string' ? v.trim().toLowerCase() : v);

export const contactFormSchema = z.object({
  name: z.preprocess(
    trim,
    z
      .string()
      .min(1, 'Name is required')
      .min(2, 'Name must be at least 2 characters')
      .max(100, 'Name must be less than 100 characters')
  ),
  email: z.preprocess(
    toLowerTrim,
    z
      .string()
      .min(1, 'Email is required')
      .email('Please enter a valid email address')
  ),
  topic: z.enum(['Support', 'Feedback', 'Bug'], {
    errorMap: () => ({ message: 'Please select a topic' })
  }),
  message: z.preprocess(
    trim,
    z
      .string()
      .min(1, 'Message is required')
      .min(10, 'Message must be at least 10 characters')
      .max(1000, 'Message must be less than 1000 characters')
  )
});

// Client-side helper (does not throw)
export const validateContactForm = (data) => {
  const result = contactFormSchema.safeParse(data);
  if (result.success) {
    return { success: true, data: result.data, errors: {} };
  }
  const fieldErrors = {};
  for (const err of result.error.errors) {
    const field = err.path?.[0];
    if (field) fieldErrors[field] = err.message;
  }
  return { success: false, data: null, errors: fieldErrors };
};

// Server-side helper used by API route
export const validateAllFields = (payload = {}) => {
  const result = contactFormSchema.safeParse(payload);
  if (result.success) {
    return { ok: true, data: result.data, errors: {} };
  }
  const errors = {};
  for (const err of result.error.errors) {
    const field = err.path?.[0];
    if (field) errors[field] = err.message;
  }
  // Provide a normalized shape even on error for convenience
  const data = {
    name: typeof payload?.name === 'string' ? payload.name.trim() : '',
    email: typeof payload?.email === 'string' ? payload.email.trim().toLowerCase() : '',
    topic: typeof payload?.topic === 'string' ? payload.topic : '',
    message: typeof payload?.message === 'string' ? payload.message.trim() : ''
  };
  return { ok: false, data, errors };
};
